export const SITUATION = {
    ATIVO: 'ATIVO',
    INATIVO: 'INATIVO',
};
  